import DeliveryNotesInfoType from "../../../types/DeliveryNotesInfoType";
import DeliveryNoteVehiclesDetails from "./DeliveryNoteVehiclesDetails";

interface Props {
  deliveryNotesInfo?: DeliveryNotesInfoType[];
}
export const DeliveryNotesInfoDetails = (props: Props) => {
  return (
    <>
      {props.deliveryNotesInfo?.map((deliveryNotesInfo, index) => (
        <DeliveryNoteVehiclesDetails
          deliveryNotesInfo={deliveryNotesInfo}
          index={index}
        />
      ))}
    </>
  );
};
